import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {purchaseOrderActions} from "./purchaseOrderSlice";
import {purchaseOrderApi} from "~/api";

function* fetchPurchaseOrderList(action) {
	try {
		const response = yield call(purchaseOrderApi.gets, action.payload);
		yield put(purchaseOrderActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch purchase order list', error);
		yield put(purchaseOrderActions.fetchDataFailed(error.message));
	}
}

function* handleSearchDebounce(action) {
	yield put(purchaseOrderActions.setFilter(action.payload));
}

export default function* purchaseOrderSaga() {
	yield takeLatest(purchaseOrderActions.fetchData.type, fetchPurchaseOrderList);
	yield debounce(500, purchaseOrderActions.setFilterWithDebounce.type, handleSearchDebounce)
}
